<template>
  <div class="map">
    <header class="map-header">
      <p class="map-header__title">教育信息化建设</p>
      <div style="text-align: center;">
        <span class="map-header__people">今日信息化应用人次:</span>
        <span :class="{'map-header__text': item!== ',',
        'map-header__bottom': item  === ','}"
          v-for="(item, index) in numberChange()"
          :key="index"
        >{{item}}</span>
      </div>
    </header>
    <div class="fx">
      <transition name="fade">
        <div v-if="showType" class="map-top">
          <p>**市***区中学</p>
          <p>在线教师数: {{teacherNumber}} 人</p>
          <p>在线学生数: {{studentNumber}} 人</p>
        </div>
      </transition>
      <div @click="mapClick()" ref="map" class="map-echarts"></div>
    </div>
    <transition name="map">
      <div v-show="mapType" ref="left" class="map-teacher left">
        <div class="map-teacher__message">
          <div>{{nameOrder[nameId]}}老师</div>
          <div class="map-teacher__time">{{date}}</div>
          <div style="width: 100%"></div>
          <div style="font-size: 14px">发布了课后测评</div>
          <div style="font-size: 14px">**市**中</div>
        </div>
      </div>
    </transition>
    <transition name="right">
      <div v-show="mapType" ref="right" class="map-teacher right">
        <div class="map-teacher__message">
          <div>{{nameOrder[otherId]}}老师</div>
          <div class="map-teacher__time">{{date}}</div>
          <div style="width: 100%"></div>
          <div style="font-size: 14px">发布了课后测评</div>
          <div style="font-size: 14px">**市**小学</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import uploadedDataURL from '@/views/pt/exhibition/components/shushan.json';
import dayjs from 'dayjs';

export default {
  name: 'Map',
  data() {
    return {
      peopleNumber: 36824907,
      timer: '',
      type: false,
      showType: false,
      teacherNumber: 20,
      studentNumber: 1200,
      mapTimer: '',
      clearTimer: '',
      showTimer: '',
      mapType: true,
      date: dayjs(new Date()).format('YYYY-MM-DD HH:mm'),
      nameId: 1,
      otherId: 2,
      nameOrder: ['赵', '吴', '冯', '陈', '蒋', '马', '苏', '吕', '周', '郑', '王', '杜', '江', '闵', '席', '徐', '何', '罗', '钟', '沈'],
    };
  },
  mounted() {
    this.init();
    console.log(this.numberChange());
    this.timer = setInterval(() => {
      this.peopleNumber += Math.ceil(Math.random() * 999 + 100);
    }, 60000);
    this.mapTimer = setInterval(() => {
      clearInterval(this.clearTimer);
      this.mapType = true;
      console.log('xiaoguo');
      this.nameId = Math.ceil(Math.random() * 19);
      this.otherId = Math.ceil(Math.random() * 19);
      this.$refs.left.style.left = `${Math.ceil(Math.random() * 230 + 70)}px`;
      this.$refs.left.style.top = `${Math.ceil(Math.random() * 400 + 200)}px`;
      this.$refs.right.style.right = `${Math.ceil(Math.random() * 230 + 70)}px`;
      this.$refs.right.style.top = `${Math.ceil(Math.random() * 400 + 400)}px`;
      setTimeout(() => {
        this.mapType = false;
        this.showType = false;
      }, 10000);
    }, 30000);
    this.clearTimer = setInterval(() => {
      this.mapType = false;
      this.showType = false;
    }, 10000);
  },
  methods: {
    mapClick() {
      this.showType = false;
      clearInterval(this.showTimer);
      if (this.type) {
        // console.log(e);
        this.showType = true;
        this.teacherNumber = Math.ceil(Math.random() * 31 + 20);
        this.studentNumber = Math.ceil(Math.random() * 1001 + 1000);
        this.showTimer = setInterval(() => {
          this.showType = false;
        }, 10000);
      }
    },
    init() {
      this.chart = this.$echarts.init(this.$refs.map);
      this.$echarts.registerMap('zibo', uploadedDataURL);
      const geoCoordMap = {
        学校0: [117.237534, 31.761485],
        学校1: [117.168347, 31.827575500000002],
        学校2: [117.1613835, 31.835265999999997],
        学校3: [117.1708845, 31.8498565],
        学校4: [117.17114799999999, 31.867295499999997],
        学校5: [117.161256, 31.870064499999998],
        学校6: [117.198622, 31.835180],
        学校7: [117.072966, 31.866093],
        学校8: [117.1505495, 31.874355],
        学校9: [116.934282, 31.974861],
        学校10: [117.14150599999999, 31.870173],
        学校11: [117.208235, 31.838680],
        学校12: [117.033827, 31.866676],
        学校13: [117.226775, 31.869591],
        学校14: [116.989882, 31.934879],
        学校15: [116.917098, 31.945368],
        学校16: [117.017348, 31.899910],
        学校17: [117.129036, 31.8750495],
        学校18: [117.241881, 31.838097],
        学校19: [117.044145, 31.978938],
        学校20: [117.1183315, 31.873230999999997],
        学校21: [117.223342, 31.849763],
        学校22: [117.11335700000001, 31.881318],
        学校23: [117.059938, 31.885117],
        学校24: [117.095402, 31.888275999999998],
        学校25: [116.985093, 31.946898],
        学校26: [117.08491000000001, 31.897207],
        学校27: [117.072655, 31.9092045],
        学校28: [117.0741585, 31.9258135],
        学校29: [117.05317249999999, 31.9353895],
        学校30: [117.02399199999999, 31.939231499999998],
        学校31: [117.0069175, 31.9266255],
        学校32: [116.966105, 31.91091],
        学校33: [116.9754355, 31.897072],
        学校34: [116.998357, 31.874285],
        学校35: [117.000086, 31.8615445],
        学校36: [116.98550399999999, 31.848199],
        学校37: [117.002298, 31.8305315],
        学校38: [117.018813, 31.8201975],
        学校39: [117.0281055, 31.815527],
        学校40: [117.052622, 31.8224605],
        学校41: [117.065479, 31.8244805],
        学校42: [116.947997, 31.812427],
        学校43: [117.033845, 31.853044],
        学校44: [116.926711, 31.906905],
        学校45: [117.0922435, 31.8198335],
        学校46: [117.116011, 31.8400605],
        学校47: [117.116243, 31.854211],
        学校48: [117.136414, 31.838152],
        学校49: [116.926711, 31.906905],
        学校50: [117.1401765, 31.8245565],
        学校51: [117.072984, 31.857127],
      };
      // 将坐标与值对应并反映在地图上
      const convertData = (data) => {
        const res = [];
        data.forEach((item) => {
          const geoCoord = geoCoordMap[item.name];
          if (geoCoord) {
            res.push({
              name: item.name,
              value: geoCoord.concat(item.value),
            });
          }
        });
        return res;
      };
      const that = this;
      this.chart.setOption({
        animation: false,
        // geo方式地理坐标系组件。
        geo: {
          map: 'zibo',
          zoom: 1.2,
          label: {
            show: true,
            color: '#fff',
            fontSize: 25,
            // 高亮状态下的多边形和标签样式。

          },
          // 选中状态下的多边形和标签样式
          emphasis: {
            itemStyle: {
              color: 'rgba(42, 16, 178, 0.6)', // 地图背景色
              borderColor: '#24C7FC', // 省市边界线00fcff 516a89
              borderWidth: 1,
            },
            label: {
              color: '#fff',
            },

          },
          // aspectScale:0.75, //长宽比
          roam: false, // 是否允许缩放
          itemStyle: {
            normal: {
              color: 'rgba(42, 16, 178, 0.6)', // 地图背景色
              borderColor: '#24C7FC', // 省市边界线00fcff 516a89
              borderWidth: 1.5,
            },
          },
        },
        tooltip: { // 自定义提示框信息
          trigger: 'item',
          formatter(params) {
            // console.log(params);// 这里可以看一下打印出来的数据格式，然后赋值到下面
            if (params.componentSubType === 'effectScatter') {
              that.type = true;
            } else {
              that.type = false;
            }
          },
        },
        series: [
          {
            type: 'effectScatter',
            color: '#FCE204',
            coordinateSystem: 'geo',
            data: convertData([
              { name: '学校0', value: 0 },
              { name: '学校1', value: 100 },
              { name: '学校2', value: 200 },
              { name: '学校3', value: 300 },
              { name: '学校4', value: 400 },
              { name: '学校5', value: 500 },
              { name: '学校6', value: 600 },
              { name: '学校7', value: 700 },
              { name: '学校8', value: 800 },
              { name: '学校9', value: 900 },
              { name: '学校10', value: 1000 },
              { name: '学校11', value: 1100 },
              { name: '学校12', value: 1200 },
              { name: '学校13', value: 1300 },
              { name: '学校14', value: 1400 },
              { name: '学校15', value: 1500 },
              { name: '学校16', value: 1600 },
              { name: '学校17', value: 1700 },
              { name: '学校18', value: 1800 },
              { name: '学校19', value: 1900 },
              { name: '学校20', value: 2000 },
              { name: '学校21', value: 2100 },
              { name: '学校22', value: 2200 },
              { name: '学校23', value: 2300 },
              { name: '学校24', value: 2400 },
              { name: '学校25', value: 2500 },
              { name: '学校26', value: 2600 },
              { name: '学校27', value: 2700 },
              { name: '学校28', value: 2800 },
              { name: '学校29', value: 2900 },
              { name: '学校30', value: 3000 },
              { name: '学校31', value: 3100 },
              { name: '学校32', value: 3200 },
              { name: '学校33', value: 3300 },
              { name: '学校34', value: 3400 },
              { name: '学校35', value: 3500 },
              { name: '学校36', value: 3600 },
              { name: '学校37', value: 3700 },
              { name: '学校38', value: 3800 },
              { name: '学校39', value: 3900 },
              { name: '学校40', value: 4000 },
              { name: '学校41', value: 4100 },
              { name: '学校42', value: 4200 },
              { name: '学校43', value: 4300 },
              { name: '学校44', value: 4400 },
              { name: '学校45', value: 4500 },
              { name: '学校46', value: 4600 },
              { name: '学校47', value: 4700 },
              { name: '学校48', value: 4800 },
              { name: '学校49', value: 4900 },
              { name: '学校50', value: 5000 },
              { name: '学校51', value: 5100 },
            ]),
            symbolSize: 10,
            rippleEffect: {
              number: 4,
              period: 7,
              scale: 3,
            },
            label: {
              normal: {
                show: false,
                formatter: '',
                position: 'right',
              },
              emphasis: {
                show: true,
              },
            },
            itemStyle: {
              emphasis: {
                borderColor: '#823960',
                borderWidth: 5,

              },
            },
          },
        ],
      }, true);
    },
    numberChange() {
      return Number(this.peopleNumber).toLocaleString();
    },
  },
  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.mapTimer);
    clearInterval(this.clearTimer);
    clearInterval(this.showTimer);
  },
};
</script>

<style lang="scss" scoped>
  .map {
    width: 100%;
    height: 100%;
    position: relative;
    font-family: PingFangSC-Medium, PingFang SC;
    display: flex;
    flex-direction: column;
    &-header {
      box-sizing: border-box;
      height: 154px;
      padding: 0 20px 20px 20px;
      color: #f5f5f5;
      &__title {
        font-size: 26px;
        font-weight: 500;
        color: #F5F5FF;
        text-align: center;
        letter-spacing: 3px;
        margin-bottom: 20px;
      }
      &__people {
        display: inline-block;
        margin-right: 10px;
        line-height: 58px;
        letter-spacing: 2px;
        font-size: 16px;
        position: relative;
        top: -10px;
      }
      &__text {
        text-align: center;
        display: inline-block;
        width: 44px;
        height: 58px;
        line-height: 58px;
        margin-right: 10px;
        color: #f5f5f5;
        font-size: 50px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        background: linear-gradient(180deg, #0A54EA 0%, #4D07CF 100%);
        border-radius: 2px;
        border: 1px solid rgba(112, 65, 255, 1);
        border-image: linear-gradient(180deg, rgba(55, 110, 255, 1), rgba(112, 65, 255, 1)) 1 1;
      }
      &__bottom {
        font-size: 50px;
        margin-right: 10px;
      }
    }
    .fx {
      position: relative;
      flex: 1;
    }
    &-echarts {
      width: 90%;
      height: 100%;
      margin-left: 56px;
      background: url('../../images/exhibition-hot.png') no-repeat left top / 100% 100%;
    }
    &-top {
      position: absolute;
      box-sizing: border-box;
      width: 178px;
      height: 98px;
      right: 240px;
      top: 150px;
      padding: 10px 20px 0 20px;
      background: url('../../images/exhibition-dialog_bg.png') no-repeat left top / 100% 100%;
      p {
        margin-top: 5px;
        // text-align: center;
        color: #01264F;
      }
    }
    &-teacher {
      position: absolute;
      width: 309px;
      background-color: red;
      bottom: 100px;
      height: 85px;
      background: url('../../images/exhibition-teacher_bg.png') no-repeat left top / 100% 100%;
      &__message {
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 20px;
        color: #01264F;
        margin-left: 54px;
        margin-top: 20px;
        font-size: 20px;
      }
      &__time {
        font-size: 16px;
        text-indent: 15px;
        line-height: 28px;
      }
    }
    .left {
      left: 70px;
      top: 300px;
    }
    .right {
      right: 70px;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .map-enter-active, .map-leave-active {
    transition: opacity .5s;
  }
  .map-enter, .map-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .right-enter-active, .right-leave-active {
    transition: opacity .5s;
  }
  .right-enter, .right-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
